import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Search as SearchIcon } from '@mui/icons-material';
import './SearchBar.scss';

/** @param {import('@mui/material').TextFieldProps} param0 */
const SearchBar = ({ className, ...props }) => {
    const { t } = useTranslation('common');
    return (
        <TextField
            size="small"
            variant="outlined"
            {...props}
            className={`${className || ''} search`}
            placeholder={t('actions.searchPlaceholder')}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                )
            }}
        />
    );
};

export default SearchBar;
